<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>国际化配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat
          :currentPage="currentPage"
          :currentSize="currentSize"
          :descCode="descCode"
          :chinese="chinese"
        ></Creat>
       
        <el-input placeholder="请输入code" clearable v-model="descCode">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入中文" clearable v-model="chinese">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div>
        <List
          :currentPage="currentPage"
          :currentSize="currentSize"
          :descCode="descCode"
          :chinese="chinese"
        ></List>
        <PageNation
          :total="totalCount"
          :size="currentSize"
          :page="currentPage"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import Creat from "./components/creat";
import List from "./components/list";
import PageNation from "../../../components/pagination";

export default {
  name: "countryCode",
  data() {
    return {
      dialogVisible: false,
      descCode: "",
      chinese: "",
      currentPage:1,
      currentSize:10,
      options: [
        {
          value: "zh",
          label: "中文",
        },
       
      ],
      total: "",
      page: 1,
      size: 10,
      obj: {},
    };
  },
  components: {
    Creat,
    List,
    PageNation,
  },

  computed: {
    ...mapState("config-i18n", ["codelist", "totalCount"]),
  },
  methods: {
    ...mapActions("config-i18n", ["getlist"]),
    closeDialog() {},
    async handleSearch() {
      this.currentPage = 1;
      await this.getlist({
        descCode:this.descCode,
        chinese: this.chinese,
        page: 1,
        size: this.currentSize,
      });
    },
    handlePageChanged(e) {
      this.currentPage = e.page;
      this.currentSize = e.size;
      this.getlist({
        ...e,
        descCode: this.descCode,
        chinese: this.chinese,
      });
    },
    pageChanged(){

    }
  },
 
  
};
</script>

<style lang="less" scoped></style>
